function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconRadioButtonSelected = function SvgIconRadioButtonSelected(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26"
  }, props), h("path", {
    fill: "#06b4ff",
    d: "M26 13A13 13 0 1 1 13 0a13 13 0 0 1 13 13m-14.5 6.883 9.645-9.645a.84.84 0 0 0 0-1.185L19.96 7.868a.84.84 0 0 0-1.185 0L10.9 15.731l-3.675-3.675a.84.84 0 0 0-1.185 0l-1.185 1.185a.84.84 0 0 0 0 1.185l5.452 5.452a.83.83 0 0 0 1.185.005Z"
  }));
};
export default SvgIconRadioButtonSelected;